export default "__VITE_ASSET__B_PKZ9$d__"